import { render, staticRenderFns } from "./mapAlpha.vue?vue&type=template&id=70a96b4a&scoped=true"
import script from "./mapAlpha.vue?vue&type=script&lang=js"
export * from "./mapAlpha.vue?vue&type=script&lang=js"
import style0 from "./mapAlpha.vue?vue&type=style&index=0&id=70a96b4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a96b4a",
  null
  
)

export default component.exports